// extracted by mini-css-extract-plugin
export default {"player-pick":"E7oAhRgDKY36QyM74g47aw==","tag":"v7dsrZ0KtVfqBl6C1yDO5A==","text":"_0Qmxwl9oVyzhSKB3SyBLUg=="};